import { MODULES } from './permissionMatrix'

export const DAY_LIMIT_MATRIX = [
  {
    module: MODULES.STOCK,
    moduleLabel: 'Kho hàng',
    groups: [
      {
        group: 'Nhập kho',
        features: [{ key: 'stockImportManagement', label: 'Nhập kho' }],
      },
      {
        group: 'Xuất kho',
        features: [{ key: 'stockExportManagement', label: 'Xuất kho' }],
      },
      {
        group: 'Chuyển kho',
        features: [
          { key: 'stockTransferRequestManagement', label: 'Phiếu yêu cầu chuyển kho' },
          { key: 'stockTransferSlipManagement', label: 'Phiếu chuyển kho' },
        ],
      },
    ],
  },
  {
    module: MODULES.ORDER,
    moduleLabel: 'Đơn hàng',
    groups: [
      {
        group: 'Đơn hàng',
        features: [{ key: 'orderManagement', label: 'Quản lý đơn hàng' }],
      },
      {
        group: 'Đơn sàn',
        features: [{ key: 'ecomOrderManagement', label: 'Quản lý đơn hàng sàn' }],
      },
    ],
  },
  {
    module: MODULES.SALES,
    moduleLabel: 'Hoá đơn',
    groups: [
      {
        group: 'Hoá đơn bán lẻ',
        features: [{ key: 'billRetailManagement', label: 'Quản lý hoá đơn bán lẻ' }],
      },
      {
        group: 'Hoá đơn bán buôn',
        features: [{ key: 'billWholesaleManagement', label: 'Quản lý hoá đơn bán buôn' }],
      },
      {
        group: 'Hoá đơn giao hàng',
        features: [{ key: 'billDeliveryManagement', label: 'Quản lý giao hàng' }],
      },
      {
        group: 'Hoá đơn trả hàng',
        features: [{ key: 'billReturnManagement', label: 'Quản lý trả hàng' }],
      },
    ],
  },
  {
    module: MODULES.ACCOUNTING,
    moduleLabel: 'Kế toán',
    groups: [
      {
        group: 'Thu chi tiền mặt',
        features: [{ key: 'transactionCashManagement', label: 'Quản lý thu chi tiền mặt' }],
      },
      {
        group: 'Thu chi ngân hàng',
        features: [{ key: 'transactionBankManagement', label: 'Quản lý thu chi ngân hàng' }],
      },
      {
        group: 'Tổng hợp thu chi',
        features: [{ key: 'transactionCashbookManagement', label: 'Quản lý tổng hợp thu chi' }],
      },
    ],
  },
]

// Danh sách phẳng tất cả featureKey để dùng khi parse API response
export const ALL_DAY_LIMIT_FEATURE_KEYS = DAY_LIMIT_MATRIX.flatMap((m) =>
  m.groups.flatMap((g) => g.features.map((f) => f.key)),
)
